import React from "react";
import FlashCardService from "../../services/content/FlashCardService";
import WordViewStates, { WordViewProps } from "./WordView.models";
import wordCardImage from '../../assest/images/card-image/wordCard.png'
import './WordView.scss';
import NotifyContext from "../../contexts/NotifyContext";

export default class WordView extends React.PureComponent<WordViewProps, WordViewStates> {

    flashCardService: FlashCardService;
    static contextType = NotifyContext;
    constructor(props: WordViewProps) {
        super(props);
        this.flashCardService = new FlashCardService();

        this.state = { boxId: '', datas: [], skip: '0', selectedCard: 1, showedNotify: false }
    }


    componentDidMount = () => {
        if (this.props.boxId !== null && this.props.boxId !== undefined && this.props.skip !== null && this.props.skip !== undefined) {
            this.setState({ boxId: this.props.boxId });
            this.getPaged();
        }
    }

    componentDidUpdate = (prevProps: WordViewProps) => {
        if ((prevProps.boxId !== this.props.boxId && this.props.boxId !== null && this.props.boxId !== undefined)) {
            this.setState({ boxId: this.props.boxId });
            this.getPaged();
        }
        else if ((prevProps.skip !== this.props.skip && this.props.skip !== null && this.props.skip !== undefined)) {
            this.setState({ skip: this.props.skip });
            this.getPaged();
        }
    }

    getPaged = () => {
        let state = this;
        this.flashCardService.getPaged(this.props.boxId as string, { pageSkip: Number.parseInt(this.props.skip as string), pageSize: 50, orderField: "ID", descendingOrder: true }).then(response => {
            state.setState({ datas: response.rows })
        })
    }

    changeStep = (changeStep: number) => {
        if (this.state.selectedCard === 1 && changeStep === -1) { return; }
        else if (this.state.datas.length !== this.state.selectedCard || changeStep === -1)
            this.setState({ selectedCard: this.state.selectedCard + changeStep, showedNotify: false })
        else if (!this.state.showedNotify) {
            this.context.showNotify({ badge: "success", title: "تبریک !!!", description: "شما تمام کلمات این دسته را مرور کردید" });
            this.setState({ showedNotify: true })
        }

    }

    deleteFlashCard = () => {
        let id = this.state.datas[this.state.selectedCard - 1].id
        console.log('length', this.state.datas.length)
        console.log('selectedCard', this.state.selectedCard)

        if (window.confirm('آیا از حذف این فلش کارت اطمینان دارید؟'))
            this.flashCardService.delete(id).then(() => {
                this.getPaged()
            })
    }

    render(): React.ReactNode {
        let { datas, selectedCard } = this.state;
        let content;
        content = <>
            <div className="col-12">
                {
                    datas.map((word, key) => {
                        let show = key + 1;
                        if (show === selectedCard)
                            return <div key={key}>
                                <label className="card-title">
                                    {word.word}
                                </label>
                                {this.titleValueView("معنی", word.mean)}
                                {this.titleValueView("تعریف", word.definition)}
                            </div>
                        else return <></>
                    })
                }
                {
                    (datas.length == 0 || datas.length <= selectedCard - 1) && <label className="card-title">موردی جهت نمایش وجود ندارد</label>
                }
            </div>



            <div className="word-card-footer-area bottom-position text-center">
                <button className="btn btn-primary" onClick={() => this.changeStep(+1)}>بعدی</button>
                <button className="btn btn-outline-danger" style={{ padding: '0 12px' }} onClick={() => this.deleteFlashCard()}>
                    <i className="mdi mdi-18px mdi-delete"></i>
                </button>
                <button className="btn btn-outline-secondary" onClick={() => this.changeStep(-1)}>قبلی</button>
            </div>
        </>;

        return <>
            <div className="col-12 word-card-view-area p-0">
                <div className="tk-card pb-4 px-2">
                    <div className="word-card-image pb-3">
                        <img src={wordCardImage} alt="pencil icon " />
                    </div>
                    {content}
                </div>
            </div>
        </>
    }

    titleValueView(title: string, value: string) {
        return <>
            <div className="word-card-title-value-view-area">
                <label className="title">
                    {title}
                </label>
                <label className="value">
                    {value}
                </label>
            </div>
        </>
    }
}